import React, { Component } from 'react'
import ReactToggle from 'react-bootstrap-toggle'
import PropTypes from 'prop-types'

class ToggleField extends Component {
  constructor (props) {
    super(props)
    this.state = { toggleActive: false }
    this.onToggle = this.onToggle.bind(this)
  }

  async onToggle () {
    await this.setState({
      toggleActive: !this.state.toggleActive
    })
    this.props.input.onChange(this.state.toggleActive)
  }

  async componentDidMount () {
    await this.setState({
      toggleActive: this.props.checked
    })
  }

  render () {
    return (
      <ReactToggle
        onClick={this.onToggle}
        on={<span style={{ fontSize: 10 }}>ON</span>}
        off={<span style={{ fontSize: 10 }}>OFF</span>}
        size='medium'
        offstyle='default'
        onstyle='success'
        active={this.state.toggleActive}
        {...this.props.input}
      />
    )
  }
}

ToggleField.propTypes = {
  input: PropTypes.any,
  checked: PropTypes.bool
}

export default ToggleField



// WEBPACK FOOTER //
// ./src/components/form/toggle/index.js